import React from 'react'
import Markdown from 'marked-react'

interface Props {
  rawMarkdown: string
  onImageLoad?: any
}

export const MarkdownComponent: React.FC<Props> = ({ rawMarkdown, onImageLoad }) => {
  const renderer = {
    image: (src: string) => {
      return <img key={src} src={src} onLoad={onImageLoad} alt="" />
    },
  }

  return <Markdown renderer={renderer} value={rawMarkdown} breaks={true} />
}
